export enum EditMode {
    View,
    Edit,
}

export interface WacFileEditState {
    fileUrl: string;
    editAllowed: boolean;
    mode: EditMode;
}
